import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {Constants} from '../../common/constants';
import {Set} from '../../model/set';
import {Report} from '../../model/report';
import {MasbitHttpService} from '../../common/http/masbit-http.service';
import {Dictionary} from "../../model/dictionary";

@Injectable()
export class ReportsService {

  static readonly ASSIGN_SETS_SERVICE_URL = environment.apiUrl.concat(environment.reportUpdateServiceUrl);
  static readonly GET_REPORT_SERVICE_URL = environment.apiUrl.concat(environment.reportGetServiceUrl);
  static readonly UPDATE_REPORT_SERVICE_URL = environment.apiUrl.concat(environment.reportUpdateServiceUrl);
  static readonly REMOVE_DEMO_FILE = environment.apiUrl.concat(environment.reportRemoveDemoFile);
  static readonly REPLACE_REPORT_FILE_SERVICE_URL = environment.apiUrl.concat(environment.replaceReportFileUrl);

    constructor(
      private httpClient : MasbitHttpService,
    ) { }

    getReportList(httpParems: HttpParams): Observable<any> {
        return this.httpClient
            .post(environment.apiUrl + '/report/list', httpParems);
    }

    getReportFilterList(httpParams: HttpParams): Observable<any> {
        return this.httpClient
            .post(environment.apiUrl + '/report/list', httpParams);
            // .post(environment.apiUrl + '/report/list/no_loader', formData);
    }

    deleteReports(reportData: Array<number>): Observable<any> {
        return this.httpClient.delete(environment.apiUrl + '/report/remove', new HttpParams().set('id', JSON.stringify(reportData)));
    }

    updateReport(formData: any): Observable<any> {
        return this.httpClient.put(environment.apiUrl + '/report', formData);
    }
    uploadDemoFile(file: any, id: any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('id', id);
        formData.append('file', file, file.name);
        return this.httpClient
            .post(environment.apiUrl + '/report/upload_demo', formData, true);
    }
    uploadFile(reportFile: any): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', reportFile, reportFile.name);
        return this.httpClient
            .post(environment.apiUrl + '/report/upload', formData, true);
    }

    replaceReportFile(file: any, id : string) : Observable<BackendServiceResponse<number, Array<Report>>> {
      const formData : FormData = new FormData();
      formData.append('id', id);
      formData.append('file', file, file.name);
      return this.httpClient
        .post<BackendServiceResponse<number, Array<Report>>>(ReportsService.REPLACE_REPORT_FILE_SERVICE_URL, formData);
    }

    getSets(sortString : String) : Observable<BackendServiceResponse<number, Array<Set>>> {
        return this.httpClient.post<BackendServiceResponse<number, Array<Set>>>(Constants.GET_SETS_URL, {sortString : sortString});
    }

    assignSets(reportId : number, sets : Array<Set>) : Observable<BackendServiceResponse<string, Report>> {
        let setsIds : Array<number> = [];
        sets.forEach(set=>{
            setsIds.push(set.id);
        });

        return this.httpClient.post<BackendServiceResponse<string, Report>>(ReportsService.ASSIGN_SETS_SERVICE_URL, {id: reportId, sets: setsIds});
    }

    getReport(reportId : string) : Observable<BackendServiceResponse<number, Array<Report>>> {
      return this.httpClient.post<BackendServiceResponse<number, Array<Report>>>(ReportsService.GET_REPORT_SERVICE_URL, {id : reportId});
    }

    unpublishReport(reportId : number) : Observable<BackendServiceResponse<string, Report>> {
      let params = {
        id : reportId,
        publishFrom : 'unpublish',
        published : false
      };
      return this.httpClient.post<BackendServiceResponse<string, Report>>(ReportsService.UPDATE_REPORT_SERVICE_URL, params)
    }

    updateReportFromReports(reportData : any) : Observable<BackendServiceResponse<string, Report>> {
      return this.httpClient.post<BackendServiceResponse<string, Report>>(ReportsService.UPDATE_REPORT_SERVICE_URL, reportData)
    }

    removeDemoFileFromReport(reportId : string) : Observable<BackendServiceResponse<number, string>> {
        return this.httpClient.delete<BackendServiceResponse<number, string>>(ReportsService.REMOVE_DEMO_FILE, new HttpParams().set('id', reportId));
    }

    publishReport(reportId : number, date?: Date, publishImmediate? : boolean) : Observable<BackendServiceResponse<string, Report>> {
      let params = {
        id : reportId
      };
      if (publishImmediate) {
        params['published'] = true;
        params['publishFrom'] = new Date();
      } else {
        params['published'] = false;
        params['publishFrom'] = date;
      }

      return this.httpClient.post<BackendServiceResponse<string, Report>>(ReportsService.UPDATE_REPORT_SERVICE_URL, params)
    }

    getInstitutionDictionary() : Observable<Array<Dictionary>> {
      return this.httpClient.get<Array<Dictionary>>(Constants.DICT_INSTITUTION_URL);
    }

    getTitleList() : Observable<BackendServiceResponse<number, any>> {
      return this.httpClient.get<BackendServiceResponse<number, any>>(Constants.REPORT_TITLES_GET_URL);
    }

    getDemoList () : Observable<BackendServiceResponse<string, Array<string>>> {
      return this.httpClient.get<BackendServiceResponse<string, Array<string>>>(Constants.REPORT_GET_DEMO_LIST);
    }

    /**
     * Zwraca ogólną liczbę raportów filtrowanych wg parametrów określonych w @params
     * @param params
     */
    getCount(params : HttpParams) : Observable<BackendServiceResponse<number, number>> {
      return this.httpClient.post<BackendServiceResponse<number, number>>(Constants.REPORT_COUNT, params);
    }

    getFileFormats() : Observable<Array<string>> {
      return this.httpClient.get<Array<string>>(Constants.GET_FILE_FORMATS);
    }
}
